import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

/** GET /orders/:id returns { order_info }. PATCH return routes return the same shape, but we must keep it — not the raw document alone. */
function toFetchOrderShape(apiResponse) {
  if (!apiResponse) {
    return {};
  }
  if (apiResponse.order_info != null) {
    return { order_info: apiResponse.order_info };
  }
  if (apiResponse._id != null && Array.isArray(apiResponse.items)) {
    return { order_info: apiResponse };
  }
  return apiResponse;
}

export function* getOrders() {
  yield takeEvery(actions.FETCH_ORDERS_REQUESTED, function* (action) {
    try {
      const orders = yield call(actions.getOrders, action.payload);
      yield put({ type: actions.FETCH_ORDERS_SUCCEEDED, orders });
    } catch (error) {
      yield put({ type: actions.FETCH_ORDERS_FAILED, error: error.message });
    }
  });
}

export function* getOrder() {
  yield takeEvery(actions.FETCH_ORDER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.getOrder, action.payload);
      yield put({ type: actions.FETCH_ORDER_SUCCEEDED, order });
    } catch (error) {
      yield put({ type: actions.FETCH_ORDER_FAILED, error: error.message });
    }
  });
}

export function* acceptOrder() {
  yield takeEvery(actions.ACCEPT_ORDER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.acceptOrderApi, action.payload);
      yield put({ type: actions.ACCEPT_ORDER_SUCCEEDED, order });
    } catch (error) {
      yield put({
        type: actions.ACCEPT_ORDER_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export function* rejectOrder() {
  yield takeEvery(actions.REJECT_ORDER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.rejectOrderApi, action.payload);
      console.log("success");
      yield put({ type: actions.REJECT_ORDER_SUCCEEDED, order });
    } catch (error) {
      console.log("error");
      yield put({
        type: actions.REJECT_ORDER_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export function* settleBulkOrder() {
  yield takeEvery(actions.SETTLE_BULK_ORDER_REQUESTED, function* (action) {
    try {
      const result = yield call(actions.settleBulkOrderApi, action.payload);
      yield put({
        type: actions.SETTLE_BULK_ORDERS_SUCCESS,
        message: result?.message,
        not_settled_orders: result?.not_settled_orders,
      });
      yield put({ type: actions.FETCH_ORDERS_REQUESTED, payload: action.payload?.refetchParams });
    } catch (error) {
      yield put({
        type: actions.SETTLE_BULK_ORDERS_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* settleOrder() {
  yield takeEvery(actions.SETTEL_ORDER_REQUESTED, function* (action) {
    try {
      const result = yield call(actions.settleOrderApi, action.payload);
      yield put({
        type: actions.SETTEL_ORDER_SUCCEEDED,
        message: result?.message,
      });
      if (action.payload?.refetchParams) {
        yield put({ type: actions.FETCH_ORDERS_REQUESTED, payload: action.payload.refetchParams });
      }
    } catch (error) {
      yield put({
        type: actions.SETTEL_ORDER_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* deleteOrder() {
  yield takeEvery(actions.DELETE_ORDER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.deleteOrderApi, action.payload);
      yield put({ type: actions.DELETE_ORDER_SUCCEEDED, order });
    } catch (error) {
      yield put({ type: actions.DELETE_ORDER_FAILED, error: error.message });
    }
  });
}

export function* cancelOrder() {
  yield takeEvery(actions.CANCEL_ORDER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.cancelOrderApi, action.payload);
      yield put({ type: actions.CANCEL_ORDER_SUCCEEDED, order });
    } catch (error) {
      yield put({ type: actions.CANCEL_ORDER_FAILED, error: error.message });
    }
  });
}

export function* changeSupplier() {
  yield takeEvery(actions.CHANGE_SUPPLIER_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.changeSupplierApi, action.payload);
      yield put({ type: actions.CHANGE_SUPPLIER_SUCCEEDED, order });
    } catch (error) {
      yield put({ type: actions.CHANGE_SUPPLIER_FAILED, error: error.message });
    }
  });
}

export function* updateOrder() {
  yield takeEvery(actions.CHANGE_ORDER_REQUESTED, function* (action) {
    try {
      delete action.payload.order.history;
      const response = yield call(actions.updateOrderApi, action.payload);
      // Pass the full response structure to match FETCH_ORDER_SUCCEEDED format
      yield put({ type: actions.CHANGE_ORDER_SUCCEEDED, order: response });
      // Refresh order data to ensure UI is up to date
      yield put(actions.fetchOrder({ _id: action.payload._id }));
    } catch (error) {
      yield put({ 
        type: actions.CHANGE_ORDER_FAILED, 
        error: error.response?.data?.message || error.message 
      });
    }
  });
}
export function* selectGift() {
  yield takeEvery(actions.SELECT_GIFT_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.selectGiftApi, action.payload);
      yield put({ type: actions.SELECT_GIFT_SUCCEEDED, order });
    } catch (error) {
      yield put({ type: actions.SELECT_GIFT_FAILED, error: error.message });
    }
  });
}

export function* uploadCliqProof() {
  yield takeEvery(actions.UPLOAD_CLIQ_PROOF_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.uploadCliqProofApi, action.payload);
      yield put({ type: actions.UPLOAD_CLIQ_PROOF_SUCCEEDED, order });
    } catch (error) {
      yield put({
        type: actions.UPLOAD_CLIQ_PROOF_FAILED,
        error: error.message,
      });
    }
  });
}

export function* changeServiceFees() {
  yield takeEvery(actions.CHANGE_SERVICE_FEES_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.changeServiceFeesApi, action.payload);
      yield put({ type: actions.CHANGE_SERVICE_FEES_SUCCEEDED, order });
    } catch (error) {
      yield put({
        type: actions.CHANGE_SERVICE_FEES_FAILED,
        error: error.message,
      });
    }
  });
}

export function* changeOrderStatus() {
  yield takeEvery(actions.CHANGE_ORDER_STATUS_REQUESTED, function* (action) {
    try {
      const order = yield call(actions.changeOrderStatusApi, action.payload);
      yield put({ type: actions.CHANGE_ORDER_STATUS_SUCCEEDED, order });
    } catch (error) {
      yield put({
        type: actions.CHANGE_ORDER_STATUS_FAILED,
        error: error.message,
      });
    }
  });
}

export function* markItemReturned() {
  yield takeEvery(actions.MARK_ITEM_RETURNED_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.markItemReturnedApi, action.payload);
      yield put({ 
        type: actions.MARK_ITEM_RETURNED_SUCCEEDED, 
        order: toFetchOrderShape(response),
        credit_coupon: response?.credit_coupon || null
      });
    } catch (error) {
      yield put({
        type: actions.MARK_ITEM_RETURNED_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* applyCopayment() {
  yield takeEvery(actions.APPLY_COPAYMENT_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.applyCopaymentApi, action.payload);
      // Pass the full response structure to match FETCH_ORDER_SUCCEEDED format
      yield put({ 
        type: actions.APPLY_COPAYMENT_SUCCEEDED, 
        order: response 
      });
      // Refresh order data to ensure UI is up to date
      yield put(actions.fetchOrder({ _id: action.payload._id }));
    } catch (error) {
      yield put({
        type: actions.APPLY_COPAYMENT_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* acceptItemReturn() {
  yield takeEvery(actions.ACCEPT_ITEM_RETURN_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.acceptItemReturnApi, action.payload);
      yield put({ 
        type: actions.ACCEPT_ITEM_RETURN_SUCCEEDED, 
        order: toFetchOrderShape(response),
        credit_coupon: response?.credit_coupon || null
      });
    } catch (error) {
      yield put({
        type: actions.ACCEPT_ITEM_RETURN_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* rejectItemReturn() {
  yield takeEvery(actions.REJECT_ITEM_RETURN_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.rejectItemReturnApi, action.payload);
      yield put({ 
        type: actions.REJECT_ITEM_RETURN_SUCCEEDED, 
        order: toFetchOrderShape(response)
      });
    } catch (error) {
      yield put({
        type: actions.REJECT_ITEM_RETURN_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export function* refundAllItems() {
  yield takeEvery(actions.REFUND_ALL_ITEMS_REQUESTED, function* (action) {
    try {
      const response = yield call(actions.refundAllItemsApi, action.payload);
      yield put({
        type: actions.REFUND_ALL_ITEMS_SUCCEEDED,
        order: toFetchOrderShape(response),
        credit_coupon: response?.credit_coupon || null,
      });
    } catch (error) {
      yield put({
        type: actions.REFUND_ALL_ITEMS_FAILED,
        error: error.response?.data?.message || error.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getOrders),
    fork(getOrder),
    fork(acceptOrder),
    fork(rejectOrder),
    fork(settleOrder),
    fork(settleBulkOrder),
    fork(deleteOrder),
    fork(cancelOrder),
    fork(changeSupplier),
    fork(changeServiceFees),
    fork(changeOrderStatus),
    fork(updateOrder),
    fork(selectGift),
    fork(uploadCliqProof),
    fork(markItemReturned),
    fork(applyCopayment),
    fork(acceptItemReturn),
    fork(rejectItemReturn),
    fork(refundAllItems),
  ]);
}
